import React, { useState, useEffect } from "react";



type props = {
    field: {
        name: string,
        title: string,
        element?: string,
        link?: { linkName: string, url: string },
        ref?: any,
        options?: { name: string, value: any }[]
    };
    onChange: (arg: any, arg2: any) => any;
    localeValue: any;
}

const Select = ({ field, onChange, localeValue}:props) => {
    const [activeOption, setActiveOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setActiveOption(field.options.find(item => item.value === localeValue)?.name)
    }, [localeValue])

    return (
        <div className={`select ${isOpen && "open"}`}>
            <div className="selectedOption"
                onClick={() => setIsOpen(prev => !prev)}
            >
                <p>{activeOption ? activeOption : "Не выбрано"}</p>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M5.19205 5.76856L8.90654 1.31117C9.34076 0.790108 8.97024 -0.000977755 8.29197 -0.000977755L1.70803 -0.000977755C1.02976 -0.000977755 0.659236 0.790107 1.09345 1.31117L4.80794 5.76856C4.90789 5.8885 5.09211 5.8885 5.19205 5.76856Z" fill="#170021"></path></svg>
            </div>

            <div className="optionsList">
                {field.options.map(option => 
                    <p key={option.name}
                        onClick={() => {
                            setIsOpen(false);
                            onChange(field.name, option.value);
                            setActiveOption(option.name);
                        }}
                    >{option.name}</p>
                )}
            </div>
        </div>
    )
}

export default Select;